import React from 'react';

import ListPage from '../../../sharedModules/listPage/ListPage';

const XoiJobsListPage: React.FC = () => {
  const xoiJobColumns = [
    {
      name: 'Job ID',
      selector: 'job_id',
      sortable: true,
      grow: 1,
    },
    {
      name: 'XOI Created At',
      selector: 'xoi_created_at_display',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Completed At',
      selector: 'completed_at_display',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Customer Name',
      selector: 'customer_name',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Job Location',
      selector: 'job_location',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Work Order Number',
      selector: 'work_order_number',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Assignees',
      selector: (row) => row.assignee_ids.join(', '),
      sortable: false,
      grow: 2,
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={xoiJobColumns}
      controller="developers/xoi_jobs"
      defaultSort="created_at desc"
      queryPlaceholder="Filter by module name..."
      title="XOI Jobs"
    />
  );
};

export default XoiJobsListPage;
